import { getGoldBotStrategies } from "../services/goldBotStrategiesApi";
import { useGoldBotResource } from "./useGoldBotResource";

export const GOLD_BOT_STRATEGIES_POLL_INTERVAL_MS = 5000;

export function useGoldBotStrategies() {
  return useGoldBotResource(
    getGoldBotStrategies,
    GOLD_BOT_STRATEGIES_POLL_INTERVAL_MS
  );
}
